import { FC } from "react"
import { useTranslation } from "react-i18next"

import { Flex } from "components/Flex"
import Radio from "components/Radio/Radio"
import Tooltip from "components/Tooltip/Tooltip"

interface ISendInvoiceToErpRadioProps {
    sendToErp: boolean
    isZeroAmount?: boolean
    disableLater?: boolean
    onChange: (sendToErp: boolean) => void
}

const SendInvoiceToErpRadio: FC<ISendInvoiceToErpRadioProps> = ({
    sendToErp,
    isZeroAmount = false,
    disableLater = false,
    onChange,
}) => {
    const { t } = useTranslation()

    return (
        <Flex flow="column" gap="1.6rem">
            <Radio name="sendToErp"
                checked={sendToErp}
                onChange={() => onChange(true)}
                label={<>
                    {t('outgoingInvoices.now')}
                        <div className="mt-1 color-grey-500">
                            {isZeroAmount ? t('outgoingInvoices.nowDesc') : t('outgoingInvoices.nowDescERP')}
                        </div>
                </>}
            />
            <Radio name="sendToErp"
                checked={!sendToErp}
                onChange={() => onChange(false)}
                disabled={disableLater}
                label={<>
                        {t('outgoingInvoices.later') }
                        <div className="mt-1 color-grey-500">
                            {t('outgoingInvoices.laterDesc')}
                        </div>
                </>}
            />
        </Flex>
    )
}

export default SendInvoiceToErpRadio
